(() => {
if(customElements.get('junior-flags-accessory'))return;
customElements.define('junior-flags-accessory',class extends HTMLElement {
connectedCallback(){
this.formId=this.dataset.form;
this.change=e=>{if(e.target.form?.getAttribute('id')===this.formId)this.sync();};
this.submit=e=>{
 if(e.target.getAttribute('id')!==this.formId)return;
 this.sync();const name=this.querySelector('[data-jfa-name]');if(name)name.value=name.value.trim();
 const controls=[...this.querySelectorAll('[data-jfa-name],[data-jfa-number]')];
 const invalid=controls.find(x=>!x.disabled&&!x.checkValidity()),error=this.querySelector('[data-jfa-error]');
 if(invalid){e.preventDefault();e.stopImmediatePropagation();error.textContent='Enter the player number for the selected engraving upgrade.';error.hidden=false;invalid.reportValidity();invalid.focus();}else error.hidden=true;
};
document.addEventListener('change',this.change);document.addEventListener('submit',this.submit,true);this.sync();
}
disconnectedCallback(){document.removeEventListener('change',this.change);document.removeEventListener('submit',this.submit,true);}
sync(){
const scope=this.closest('product-info')||this.parentElement;
const options=Array.from(scope.querySelectorAll('variant-selects input:checked,variant-selects select'));
const engraving=options.find(x=>x.name.trim().startsWith('Engraving'));
const needed=this.dataset.kind==='pack'||!!engraving?.value.includes('+$6');
this.querySelector('[data-jfa-fields]').hidden=!needed;
this.querySelectorAll('[data-jfa-name],[data-jfa-number]').forEach(x=>{x.disabled=!needed;x.required=needed;});
}
});
})();